const styleConstants = {
    muBody2LineHeight: 1.43,
};

export default styleConstants;